<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div">
      <div class="fixed inset-0 overflow-y-auto" style="z-index: 305">
        <div class="min-h-screen px-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div>
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
              <div
                :class="`bg-${color}`"
                style="width: 888px;
                      height: 568px;
                      max-height: 568px;
                      position: fixed;
                      top: 50%;
                      left: 50%;
                      transform: translate(calc(-50% + 12px), calc(-50% + 12px));
                      border-radius: 24px 0px 24px 24px;"
              ></div>
            </div>
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              style="width: 888px; height: 568px; top: 50%;left: 50%;border-radius: 24px 0px 24px 24px; z-index: 401; position: fixed; transform: translate(-50%, -50%);"
              :class="
                `inline-block overflow-hidden text-left align-middle transition-all transform bg-${bgcolor}`
              "
            >
              <DialogTitle
                as="template"
                style="height: 58px"
                class="border-b-4 flex flex-row items-center"
                :class="`border-${color}`"
              >
                <div>
                  <slot name="dialogTitle"></slot>
                  <close-icn
                    width="20"
                    height="20"
                    class="fixed top-0 right-0 mt-4 mr-4"
                    :class="`${color}-icon`"
                    @click="closeDialog"
                  ></close-icn>
                </div>
              </DialogTitle>
              <div
                class="flex flex-col justify-between"
                style="height: 510px; max-height: 510px;"
              >
                <div style="overflow: hidden;">
                  <slot name="dialogContent"></slot>
                </div>
                <div
                  :class="
                    `flex flex-row items-center h-12 bg-${color} rounded-full mx-1 my-1`
                  "
                  style="z-index:10"
                >
                  <slot name="dialogFooterActions"></slot>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
      <TransitionRoot appear v-if="isImgPreviewOpen" as="template">
        <div class="fixed inset-0 overflow-y-auto" style="z-index: 400">
          <DialogOverlay class="fixed inset-0 bg-black opacity-50" />
          <AppImgPreviewDefaultProvider />
        </div>
      </TransitionRoot>
    </Dialog>
  </TransitionRoot>
  <!-- <TransitionRoot appear :show="isImgPreviewOpen" as="template">
    <Dialog as="div">
    <div class="fixed inset-0 overflow-y-auto" style="z-index: 400">
      <DialogOverlay class="fixed inset-0 bg-black opacity-50" />
      <AppImgPreview />
    </div>
  </Dialog>
  </TransitionRoot> -->
</template>
<script>
import { useDialog } from '@/services/useDialog'
import AppImgPreviewDefaultProvider from '@/components/provider/AppImgPreviewProvider/AppImgPreviewProvider'

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
  DialogTitle,
} from '@headlessui/vue'
import CloseIcn from '@/assets/icons/close.svg?inline'

export default {
  name: 'AppDialog',

  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
    CloseIcn,
    AppImgPreviewDefaultProvider,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
    bgcolor: {
      type: String,
      default: 'white',
    },
  },

  setup() {
    const { isImgPreviewOpen } = useDialog()
    return { ...useDialog(), isImgPreviewOpen }
  },
}
</script>
<style lang="scss"></style>
